import {
  AppConfigurationProvider,
  Environment,
} from '@dirootie-core/core-types';
import { ILogger } from '@dirootie-logging/logging-types';
import { importFileLoader } from '@dirootie-core/core';
import { ApplicationConfig } from './configuration/Configuration.types';
import { apiEndpoints } from './configuration/ApiEndpoints';

export type ConfigSource = 'HTTP' | 'IMPORT' | 'LOCAL';

export type FileLocation = { path: string; source: ConfigSource };

export type SingleFile = FileLocation;
export type EnvDynamic = {
  environment: Environment;
  pattern: string;
} & FileLocation;
export type EnvStatic = {
  files: { [P in keyof Environment]: FileLocation };
  environment: Environment;
};

export type FileConfigOptions = SingleFile | EnvStatic | EnvDynamic;

export class FileConfigurationProvider<
  AppConfig extends object = any
> extends AppConfigurationProvider<AppConfig> {
  options: any;
  constructor(logger: ILogger, options: FileConfigOptions) {
    super(logger);
    this.options = options;
  }

  loadInternal(): Promise<AppConfig> {
    const { pattern, path, environment, source, files } = this.options as any;
    if (files !== undefined && environment !== undefined) {
      return this.loadEnvStatic(this.options);
    }
    if (pattern !== undefined || environment !== undefined) {
      return this.loadEnvDynamic(this.options);
    }
    if (path !== undefined && source !== undefined) {
      return this.loadSingleFile(this.options);
    }
    return Promise.reject('No valid parameters');
  }
  setConfig(c: AppConfig | undefined) {
    this.config = c;
  }

  loadSingleFile(location: FileLocation): Promise<AppConfig> {
    const loadMapper = {
      HTTP: this.loadFromImport,
      IMPORT: this.loadFromImport,
      LOCAL: this.loadFromLocal,
    };
    return loadMapper[location.source](location.path);
  }

  loadEnvDynamic(options: EnvDynamic) {
    var configFile = require(`../../config.{env}.json`.replace(
      '{env}',
      options.environment
    ));
    return Promise.resolve(configFile);
  }

  loadSync() {
    var configFile = require(`./config.{env}.json`.replace(
      '{env}',
      process.env.REACT_APP_ENV!
    ));
    const configSettings: ApplicationConfig = { ...configFile };
    configFile.api.endpoints = { ...apiEndpoints };
    this.config = configSettings as any;
  }

  loadEnvStatic = (options: EnvStatic) =>
    this.loadSingleFile((options as any)[options.environment]);

  loadFromImport(path: string): Promise<AppConfig> {
    return importFileLoader(path);
  }
  loadFromLocal(path: string): Promise<AppConfig> {
    throw new Error('Not implemented');
  }
  loadFromHttp(url: string): Promise<AppConfig> {
    throw new Error('Not implemented');
  }
}
